import { MemoryCache } from "../../cache/cache";
import { TileAddress } from "../address/tiles.address";
export class TileContentProvider {
    constructor(datasource, cache) {
        this._datasource = datasource;
        this._cache = cache || new MemoryCache();
        if (cache) {
            this._prefix = this._buildPrefix();
            this._ownCache = false;
        }
        else {
            this._ownCache = true;
        }
    }
    accept(address) {
        return TileAddress.IsValidAddress(address, this.metrics);
    }
    get name() {
        return this._datasource.name;
    }
    get datasource() {
        return this._datasource;
    }
    get metrics() {
        return this._datasource.metrics;
    }
    dispose() {
        if (this._prefix && !this._ownCache) {
            const p = this._prefix;
            this._cache.clear((k) => k.startsWith(p));
            return;
        }
        this._cache.clear();
    }
    fetchContent(tile, callback) {
        const address = tile.address;
        const cacheKey = this._buildCacheKey(address.quadkey);
        if (this._cache.contains(cacheKey)) {
            tile.content = this._cache.get(cacheKey);
            return tile;
        }
        let c = this._buildTemporaryContent(address);
        this._cache.set(cacheKey, c);
        this._datasource.fetchAsync(address, tile).then((result) => {
            if (result.ok) {
                this._cache.set(this._buildCacheKey(address.quadkey), result.content);
                tile.content = result.content;
                callback?.(tile);
            }
            else {
                console.log(`the fetch operation has failed because of ${result.statusText}`);
                callback?.(tile);
            }
        }, (reason) => {
            console.log(`the fetch operation has failed because of ${reason}`);
            callback?.(tile);
        });
        tile.content = c;
        return tile;
    }
    _buildTemporaryContent(address) {
        return null;
    }
    _buildAlternativContent(address) {
        return null;
    }
    _buildPrefix() {
        let p = `${this.name}_${Math.floor(Math.random() * Number.MAX_SAFE_INTEGER)}_`;
        while (this._cache?.any((k) => k.startsWith(p))) {
            p = `${this.name}_${Math.floor(Math.random() * Number.MAX_SAFE_INTEGER)}_`;
        }
        return p;
    }
    _buildCacheKey(key) {
        return this._prefix ? `${key}` : `${this._prefix}${key}`;
    }
}
//# sourceMappingURL=tiles.provider.content.js.map